// extracted by mini-css-extract-plugin
module.exports = {"colorPrimary":"#ff7171","root":"AddPostButton_root__1s3-M"};